<template>
  <div class="page-container" :class="{ 'page-container--with-sidebar': isSidebarPresent }">
    <div class="admin__header">
      <h1 class="page-title">Uredi skupino uporabnikov</h1>
      <v-button class="delete-button" :disabled="isLoading" @click="onDelete" background-color="red" outlined>Izbriši</v-button>
    </div>
    <user-group-form v-show="!isLoading" @submit="submitUserGroup" @delete="onDelete" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import UserGroupForm from './forms/UserGroupForm'
import VButton from 'design-system/VButton.vue'
import prompt from 'design-system/components/prompt/prompt'

export default {
  props: {
    id: { type: [String, Number], required: true },
  },
  components: {
    UserGroupForm,
    VButton,
  },
  created () {
    this.initialize(this.id)
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState(['isLoading']),
    ...mapGetters(['accountSlug']),
  },
  methods: {
    ...mapActions('accountStore/userGroups/forms', ['initialize', 'reset', 'submitUserGroup', 'deleteUserGroup']),
    async onDelete () {
      const result = await prompt.okText('Izbriši').confirm('Res želite izbrisati skupino uporabnikov? Vsi dokumenti v tej skupini bodo preneseni v skupno rabo računa.')
      if (result) {
        this.deleteUserGroup(this.id).then(() => {
          this.$router.push({
            name: 'account_user_groups_path',
            params: {
              accountId: this.accountSlug,
            },
          })
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/admin_common';
@import '@/components/common';
</style>
